package com.sddamico.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.SitePalette
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
fun StatusBadge(label: String, bgColor: Color, textColor: Color = Colors.White) {
    Div(
        Modifier
            .backgroundColor(bgColor)
            .color(textColor)
            .borderRadius(9999.px)
            .padding(topBottom = 0.2.cssRem, leftRight = 0.6.cssRem)
            .fontSize(0.6875.cssRem)
            .fontWeight(500)
            .lineHeight(1.4)
            .toAttrs()
    ) {
        Text(label)
    }
}

@Composable
fun TournamentStatusBadge(status: String) {
    when (status) {
        "ACTIVE" -> StatusBadge("In Progress", SitePalette.statusActive)
        "COMPLETED" -> StatusBadge("Final", SitePalette.statusFinal)
        "FUTURE" -> StatusBadge("Upcoming", SitePalette.border, SitePalette.textSecondary)
    }
}

@Composable
fun SportBadge(sport: String, isLiv: Boolean = false) {
    val (label, color) = when {
        sport == "MENS_GOLF" && isLiv -> "LIV" to SitePalette.error
        sport == "MENS_GOLF" -> "PGA" to SitePalette.primary
        sport == "MENS_TENNIS" -> "ATP" to SitePalette.statusActive
        sport == "WOMENS_TENNIS" -> "WTA" to SitePalette.accent
        else -> sport to SitePalette.textMuted
    }
    StatusBadge(label, color)
}
